import { useEffect } from 'react';
import { LanguageContext } from '../../context/LanguageContext';
import DownloadSection from './DownloadSection';
import styles from './Games.module.css';
import GamesGallery from './GamesGallery';
import { scrollToTop } from '../../utils/helpers/utils';

export default function Games() {
  useEffect(() => {
    scrollToTop()
  }, [])

  return (
    <LanguageContext.Consumer>
      {({ data, language: lang }) => {
        const t = (key) => data?.[key]?.[lang];
        return (
          <div className={styles.wrapper}>
            <div className={styles.topSection}>
              <div className={styles.container}>
                <div className={styles.left}>
                  <span className={styles.pill}>{t("play_anywhere")}</span>
                  <h2 className={styles.title}>{t("games_mobile_promo_title")}</h2>
                  <p className={styles.text}>{t("games_mobile_flexibility_text")}</p>
                  <div className={styles.badge}>
                    <img src="/assets/intro/badge.svg" alt="" height={18} width={18} />
                    <span>{t("ad_free_environment")}</span>
                  </div>
                </div>

                <div className={styles.right}>
                  <div className={styles.imageCard}>
                    <img src="/assets/intro/welcome.jpg" alt="" className={styles.mascot}/>
                  </div>
                </div>
              </div>
            </div>
            <DownloadSection t={t}/>
            <GamesGallery t={t}/>
          </div>
        );
      }}
    </LanguageContext.Consumer>
  );
}